/* eslint-disable jsx-a11y/anchor-is-valid */
// ============================================================
// หน้า ChooseProject — เลือกโครงการที่จะเข้าไปทำงาน
// ------------------------------------------------------------
// สิ่งที่ทำได้ในหน้านี้
//   - ค้นหา/เลือกโครงการ  → เก็บข้อมูลโครงการลง localStorage แล้วเข้าหน้า /customer
//   - เจ้าของระบบ (user_type = owner) เท่านั้นที่ เพิ่ม / แก้ไข / ลบ โครงการได้
//   - ออกจากระบบ
//
// การเก็บข้อมูลโครงการลง localStorage ย้ายไปอยู่ที่ components/custom/project.js
// (selectProject) เพราะเป็นข้อมูลชุดเดียวกับที่หน้าอื่นทั้งระบบต้องใช้
// ============================================================

import React, { Component } from "react";
import { Modal, Dropdown } from "react-bootstrap";
import Select from "react-select";
import Resizer from "react-image-file-resizer";

import PROJECT from "../../assets/images/project.png";
import province from "../../shared/config/province.json";
import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import { tokens, select_style, success, GET, POST, PUT, DELETE, validate, Logout, getStorage, loading, selectProject } from "../../shared/index.js";

// หน่วงเวลาก่อนยิงค้นหา (มิลลิวินาที) — พิมพ์รัว ๆ จะยิง API แค่ครั้งเดียว
const SEARCH_DELAY = 400;

// ค่าเริ่มต้นของฟอร์มเพิ่ม/แก้ไขโครงการ (ใช้ตอนเปิดฟอร์มใหม่และตอนล้างฟอร์ม)
const EMPTY_FORM = {
  project_id: "",
  project_name: "",
  project_number: "",
  address_detail: "",
  address_id: null,
  post_code: "",
  phone_number: "",
  tax_number: "",
  picture: "",
};

export default class ChooseProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,
      modal_delete: false,
      modal_logout: false,
      data_search: "",
      data: [],
      // รายการ ตำบล/อำเภอ/จังหวัด สำหรับ dropdown (อ่านจากไฟล์ province.json)
      array_address: province.map((e) => ({
        value: e.ID,
        label: `${e.SUB_DISTRICT}, ${e.DISTRICT}, ${e.ROVINCE}`,
        zipcode: e.ZIPCODE,
      })),
      ...EMPTY_FORM,
    };
    this.picture_project = React.createRef();
    this.search_timer = null;
  }

  async componentDidMount() {
    loading(false);
    await this.GetProjectAll();
  }

  componentWillUnmount() {
    clearTimeout(this.search_timer);
  }

  // ---------- เรียกข้อมูล ----------

  // ดึงรายการโครงการทั้งหมดตามคำค้น
  GetProjectAll = async () => {
    loading(true);
    const result = await GET(tokens, `v1/TH/project-manage/filter-search/page/0?data_search=${this.state.data_search}`, null);
    if (result?.status) this.setState({ data: result.data.data });
    loading(false);
  };

  // พิมพ์ค้นหา — รอให้หยุดพิมพ์ก่อนค่อยยิง API (ลดจำนวน request ให้หน้าเร็วขึ้น)
  onSearch = (data_search) => {
    this.setState({ data_search });
    clearTimeout(this.search_timer);
    this.search_timer = setTimeout(() => this.GetProjectAll(), SEARCH_DELAY);
  };

  // ---------- บันทึก / ลบ ----------

  // บันทึกโครงการ — isUpdate = true คือแก้ไขของเดิม, false คือเพิ่มใหม่
  Save = async (isUpdate = false) => {
    if (validate(this.state, ["project_number", "project_name", "address_detail", "address_id", "post_code", "phone_number", "tax_number"])) return;

    loading(true);
    const payload = {
      project_name: this.state.project_name,
      project_number: this.state.project_number,
      address_id: this.state.address_id?.value || "",
      address_detail: this.state.address_detail,
      phone_number: this.state.phone_number,
      tax_number: this.state.tax_number,
      picture: this.state.picture,
    };
    if (isUpdate) payload.project_id = this.state.project_id;

    const result = isUpdate ? await PUT(tokens, "v1/TH/project-manage/update", payload) : await POST(tokens, "v1/TH/project-manage/create", payload);

    if (result?.status) {
      this.clear_form();
      success();
      this.GetProjectAll();
    }
    loading(false);
  };

  Delete = async () => {
    loading(true);
    const result = await DELETE(tokens, `v1/TH/project-manage/delete/${this.state.project_id}`, null);
    if (result?.status) {
      this.clear_form();
      success();
      this.GetProjectAll();
    }
    loading(false);
  };

  // ---------- ฟอร์ม / รูปภาพ ----------

  // ปิด popup ทุกตัวและล้างค่าในฟอร์ม
  clear_form = () => {
    this.setState({
      modal_create: false,
      modal_update: false,
      modal_delete: false,
      data_search: "",
      ...EMPTY_FORM,
    });
  };

  // เลือกไฟล์รูปโครงการ — ย่อเป็น 128x128 แล้วเก็บเป็น base64 (ตัดส่วนหัว data URI ออก)
  changePhotoProject = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    Resizer.imageFileResizer(file, 128, 128, "JPG", 100, 0, (uri) => this.setState({ picture: uri.split(",")[1] }), "base64");
  };

  // แปลงรูปจาก url เป็น base64 (ใช้ตอนเปิดฟอร์มแก้ไข เพื่อให้พรีวิวรูปเดิมได้)
  toDataUrl = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(",")[1]);
        reader.readAsDataURL(blob);
      });
    } catch {
      return global.logo;
    }
  };

  // เปิดฟอร์มแก้ไข พร้อมเติมข้อมูลของโครงการที่เลือก
  openUpdate = async (item) => {
    const address = this.state.array_address.find((e) => e.value === item.address_id);
    this.setState({
      modal_update: true,
      project_id: item.project_id,
      project_name: item.project_name,
      project_number: item.project_number,
      address_detail: item.address_detail,
      address_id: address,
      post_code: address?.zipcode || "",
      phone_number: item.phone_number,
      tax_number: item.tax_number,
      picture: item.picture ? await this.toDataUrl(item.picture) : "",
    });
  };

  // กดที่การ์ดโครงการ — เก็บข้อมูลโครงการแล้วเข้าหน้าแรกของระบบ
  // (ไม่ทำงานถ้ากำลังเปิด popup แก้ไข/ลบ อยู่ เพื่อไม่ให้กดโดนพร้อมกัน)
  onSelectProject = (item) => {
    if (this.state.modal_delete || this.state.modal_update) return;
    selectProject(item);
    window.location.href = "/customer";
  };

  render() {
    const { state } = this;
    const isOwner = getStorage("user_type") === "owner";

    return (
      <div className="w-100 min-vh-100 fade-in">
        <div className="w-100 min-vh-100">
          {/* หัวหน้าจอ: ทักทาย + จำนวนโครงการ */}
          <div className="w-100 pt-5 pb-3 bg-white shadow">
            <div className="container">
              <b>สวัสดี {getStorage("full_name")}</b>
              <h1>
                <b>เลือกโครงการที่ต้องการ</b>
              </h1>
              <small>{state.data.length} โครงการ</small>
            </div>
          </div>

          <div className="w-100 py-4">
            <div className="container">
              {/* แถบค้นหา + ปุ่มด้านขวา */}
              <div className="row">
                <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-3">
                  <input className="form-control border-0 shadow-sm" type="search" placeholder="ชื่อโครงการ..." onChange={(e) => this.onSearch(e.target.value)} value={state.data_search} />
                </div>
                <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-3">
                  {/* ตัวเลือกพื้นที่ (แสดงไว้ตามดีไซน์เดิม ยังไม่ได้ผูกกับการกรองข้อมูล) */}
                  <Select className="form-control border-0 shadow-sm select-search" styles={select_style} options={state.array_address} placeholder="-- เลือก --" onChange={(e) => this.setState({ province: e })} isClearable />
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-6 mb-3 d-flex justify-content-end">
                  <button className="btn btn-danger text-white mr-2 px-4" onClick={() => this.setState({ modal_logout: true })}>
                    ออกจากระบบ
                  </button>
                  {isOwner && (
                    <button className="btn btn-primary px-4" onClick={() => this.setState({ modal_create: true })}>
                      เพิ่มโครงการ
                    </button>
                  )}
                </div>
              </div>

              {/* การ์ดโครงการ */}
              <div className="row">
                {state.data.map((item, index) => (
                  <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-3" key={`div${index}`}>
                    <div className="card w-100 p-3 border-0 bg-white shadow align-items-center pointer hover hpx-180">
                      <div className="position-absolute text-center w-100 px-2" onClick={() => this.onSelectProject(item)}>
                        <img
                          className="mb-3 card border-2 rounded-2 mx-auto"
                          src={item.picture || PROJECT}
                          alt="โครงการ"
                          style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 8 }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = PROJECT;
                          }}
                        />
                        <div className="d-flex justify-content-center">
                          <div className="bg-blue px-2 py-1 rounded-sm text-white mb-2 overflow-hidden" style={{ height: 27 }}>
                            {item.project_name || "-"}
                          </div>
                        </div>
                        <div className="text-10 text-secondary mb-0">หมายเลขผู้เสียภาษี {item.tax_number || "-"}</div>
                      </div>

                      {/* เมนูเฟือง แก้ไข/ลบ — เห็นเฉพาะ owner */}
                      {isOwner && (
                        <div className="dropdowns position-absolute" style={{ right: 4, top: 2 }}>
                          <Dropdown>
                            <Dropdown.Toggle variant="gray" size="sm" className="py-0 px-1 shadow-none pointer" style={{ backgroundColor: "#00000000" }}>
                              <label className="icon text-secondary p-2">{"\uf013"}</label>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="shadow overflow-hidden border-0 rounded-4 p-2">
                              <Dropdown.Item className="rounded-3 px-2" onClick={() => this.openUpdate(item)}>
                                แก้ไข
                              </Dropdown.Item>
                              <Dropdown.Item className="rounded-3 px-2" onClick={() => this.setState({ modal_delete: true, project_id: item.project_id })}>
                                ลบ
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* popup เพิ่ม / แก้ไขโครงการ (ใช้ฟอร์มเดียวกัน ต่างกันแค่หัวข้อและปุ่ม) */}
        <Modal show={state.modal_create || state.modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })}>
          <Modal.Header>
            <Modal.Title>
              <b>{state.modal_create ? "เพิ่มโครงการ" : "แก้ไขโครงการ"}</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* รหัสโครงการ — ตัวเลข 4 หลัก */}
            <div className="d-flex align-items-center mb-3">
              <label className="wpx-140 mb-0">รหัสโครงการ:</label>
              <input className="form-control border-0 bg-contain" type="text" maxLength={4} value={state.project_number} onChange={(e) => this.setState({ project_number: e.target.value.replace(/\D/g, "") })} />
            </div>
            <div className="d-flex align-items-center mb-3">
              <label className="wpx-140 mb-0">ชื่อโครงการ:</label>
              <input className="form-control border-0 bg-contain" type="text" value={state.project_name} onChange={(e) => this.setState({ project_name: e.target.value })} />
            </div>
            <div className="d-flex mb-3">
              <label className="wpx-140 mb-0">ที่อยู่:</label>
              <textarea className="form-control border-0 bg-contain" value={state.address_detail} onChange={(e) => this.setState({ address_detail: e.target.value })}></textarea>
            </div>
            {/* เลือกตำบล/อำเภอ/จังหวัด แล้วเติมรหัสไปรษณีย์ให้อัตโนมัติ */}
            <div className="d-flex align-items-center mb-3">
              <label className="wpx-140 mb-0">ตำบล อำเภอ จังหวัด:</label>
              <Select className="form-control border-0 bg-contain select-search" styles={select_style} options={state.array_address} value={state.address_id} onChange={(e) => this.setState({ address_id: e, post_code: e?.zipcode || "" })} isClearable />
            </div>
            <div className="d-flex align-items-center mb-3">
              <label className="wpx-140 mb-0">รหัสไปรษณีย์:</label>
              <input className="form-control border-0 bg-contain" type="text" readOnly value={state.post_code} />
            </div>
            <div className="d-flex align-items-center mb-3">
              <label className="wpx-140 mb-0">เบอร์โทร:</label>
              <input className="form-control border-0 bg-contain" type="tel" maxLength={10} value={state.phone_number} onChange={(e) => this.setState({ phone_number: e.target.value.replace(/\D/g, "") })} />
            </div>
            <div className="d-flex align-items-center mb-3">
              <label className="wpx-140 mb-0">เลขผู้เสียภาษี:</label>
              <input className="form-control border-0 bg-contain" type="text" maxLength={13} value={state.tax_number} onChange={(e) => this.setState({ tax_number: e.target.value.replace(/\D/g, "") })} />
            </div>

            {/* รูปโครงการ — ยังไม่เลือกแสดงปุ่มนำเข้า, เลือกแล้วแสดงพรีวิว + ปุ่มกากบาทลบ */}
            <div className="d-flex align-items-center mb-3">
              <label className="wpx-140 mb-0">รูปโครงการ:</label>
              {!state.picture ? (
                <button className="btn btn-outline-primary w-100" onClick={() => this.picture_project.current.click()}>
                  นำเข้าไฟล์
                </button>
              ) : (
                <div className="card p-3 align-items-center text-center w-100 position-relative">
                  <img
                    alt="โครงการ"
                    src={`data:image/png;base64,${state.picture}`}
                    className="wpx-200 img-responsive"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = PROJECT;
                    }}
                  />
                  <div
                    className="wpx-32 hpx-32 rounded-circle bg-danger text-white icon text-24 d-flex justify-content-center align-items-center position-absolute pointer"
                    onClick={() => this.setState({ picture: "" })}
                    style={{ right: -6, top: -6 }}
                  >
                    {"\uf00d"}
                  </div>
                </div>
              )}
              <input className="d-none" ref={this.picture_project} onChange={this.changePhotoProject} type="file" accept="image/*" />
            </div>

            <div className="d-flex">
              <button className="btn btn-outline-primary w-50 mx-1" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                ยกเลิก
              </button>
              <button className="btn btn-primary w-50 mx-1" onClick={() => this.Save(!state.modal_create)}>
                {state.modal_create ? "เพิ่ม" : "บันทึก"}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* popup ยืนยันการลบ */}
        <Modal show={state.modal_delete} onHide={() => this.setState({ modal_delete: false })}>
          <Modal.Header>
            <Modal.Title>
              <b>ยืนยันการลบ</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>ท่านแน่ใจว่าต้องการลบข้อมูลโครงการหรือไม่? ข้อมูลจะไม่สามารถย้อนคืนได้</p>
            <div className="d-flex">
              <button className="btn btn-outline-primary w-50 mx-1" onClick={() => this.setState({ modal_delete: false })}>
                ยกเลิก
              </button>
              <button className="btn btn-danger w-50 mx-1" onClick={this.Delete}>
                ยืนยัน
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* popup ยืนยันออกจากระบบ */}
        <Modal show={state.modal_logout} onHide={() => this.setState({ modal_logout: false })}>
          <Modal.Header>
            <Modal.Title>
              <b>ออกจากระบบ</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>ยืนยันการออกจากระบบหรือไม่</p>
            <div className="d-flex">
              <button className="btn btn-outline-primary w-50 mx-1" onClick={() => this.setState({ modal_logout: false })}>
                ยกเลิก
              </button>
              <button className="btn btn-primary w-50 mx-1" onClick={Logout}>
                ออกจากระบบ
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
